<div [class]="envClass" class="popup-container">
  <mat-toolbar class="custom-toolbar">
    <span class="toolbar-title">Task</span>
    <span class="fill-empty-space"></span>
    <div class="toolbar-actions">
      <button mat-icon-button (click)="save()" class="has-tooltip" data-tooltip="Save task">
        <mat-icon>save</mat-icon>
      </button>
      <button *ngIf="task?.noteId && task?.noteId>-1" mat-icon-button (click)="followLink()" class="has-tooltip"
        data-tooltip="Open linked note">
        <mat-icon>description</mat-icon>
      </button>
      <button *ngIf="task?.noteId && task?.noteId>-1" mat-icon-button (click)="removeLink()" class="has-tooltip"
        data-tooltip="Remove link">
        <mat-icon>link_off</mat-icon>
      </button>
      <button *ngIf="task.id>0" mat-icon-button (click)="onDelete()" class="has-tooltip" data-tooltip="Delete task">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div class="content-wrapper">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Title</mat-label>
      <input matInput name="title" required [(ngModel)]="task.title">
    </mat-form-field>

    <div class="main-layout">
        <div class="document-paper">
          <!-- Custom Toolbar -->
          <div class="ck-style-toolbar" *ngIf="editor">

            <!-- Heading Selector -->
            <!--div class="toolbar-group">
              <select (change)="onHeadingChange($event)" class="heading-select">
                <option value="p" [selected]="editor.isActive('paragraph')">Paragraph</option>
                <option value="1" [selected]="editor.isActive('heading', { level: 1 })">Heading 1</option>
                <option value="2" [selected]="editor.isActive('heading', { level: 2 })">Heading 2</option>
                <option value="3" [selected]="editor.isActive('heading', { level: 3 })">Heading 3</option>
              </select>
            </div>

            <div class="divider"></div-->

            <!-- Formatting: Bold, Italic, Link, Code -->
            <div class="toolbar-group">
              <button type="button" (click)="editor.chain().focus().toggleBold().run()"
                [class.active]="editor.isActive('bold')" title="Bold">
                <mat-icon>format_bold</mat-icon>
              </button>
              <button type="button" (click)="editor.chain().focus().toggleItalic().run()"
                [class.active]="editor.isActive('italic')" title="Italic">
                <mat-icon>format_italic</mat-icon>
              </button>
            </div>

            <div class="divider"></div>

            <!-- Lists -->
            <div class="toolbar-group">
              <button type="button" (click)="editor.chain().focus().toggleBulletList().run()"
                [class.active]="editor.isActive('bulletList')" title="Bullet List">
                <mat-icon>format_list_bulleted</mat-icon>
              </button>
              <button type="button" (click)="editor.chain().focus().toggleOrderedList().run()"
                [class.active]="editor.isActive('orderedList')" title="Numbered List">
                <mat-icon>format_list_numbered</mat-icon>
              </button>
            </div>

            <div class="divider"></div>

            <!-- Alignment -->
            <div class="toolbar-group">
              <button type="button" (click)="editor.chain().focus().setTextAlign('left').run()"
                [class.active]="editor.isActive({ textAlign: 'left' })" title="Align Left">
                <mat-icon>format_align_left</mat-icon>
              </button>
              <button type="button" (click)="editor.chain().focus().setTextAlign('right').run()"
                [class.active]="editor.isActive({ textAlign: 'right' })" title="Align Right">
                <mat-icon>format_align_right</mat-icon>
              </button>
            </div>

            <div class="divider"></div>

            <!-- Tables, Quotes, Codeblock -->
            <div class="toolbar-group">
              <button type="button" (click)="editor.chain().focus().toggleBlockquote().run()"
                [class.active]="editor.isActive('blockquote')" title="Blockquote">
                <mat-icon>format_quote</mat-icon>
              </button>
              <button type="button" (click)="editor.chain().focus().toggleCodeBlock().run()"
                [class.active]="editor.isActive('codeBlock')" title="Code Block">
                <mat-icon>integration_instructions</mat-icon>
              </button>
            </div>

            <div class="divider"></div>

            <!-- Undo & Redo -->
            <div class="toolbar-group">
              <button type="button" (click)="editor.chain().focus().undo().run()" [disabled]="!editor.can().undo()"
                title="Undo">
                <mat-icon>undo</mat-icon>
              </button>
              <button type="button" (click)="editor.chain().focus().redo().run()" [disabled]="!editor.can().redo()"
                title="Redo">
                <mat-icon>redo</mat-icon>
              </button>
            </div>

            <div class="divider"></div>

            <!-- Media: Image -->
            <div class="toolbar-group">
              <button type="button" (click)="addImage()" title="Insert Image">
                <mat-icon>image</mat-icon>
              </button>
            </div>

          </div>
          <div #editorElement class="tiptap-editor-content"></div>

        </div>

      <div class="settings-column">
        <mat-form-field appearance="outline" class="tight-field">
          <mat-label>Due date</mat-label>
          <input matInput [matDatepicker]="picker" [(ngModel)]="task.dueDate">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="tight-field">
          <mat-label>Status</mat-label>
          <mat-select [(ngModel)]="task.status" required [compareWith]="functions.objectComparisonFunction">
            <mat-option value="Not started">Not started</mat-option>
            <mat-option value="In progress">In progress</mat-option>
            <mat-option *ngIf="settings && settings.showOnHold" value="On hold">On hold</mat-option>
            <mat-option value="Done">Done</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="tight-field">
          <mat-label>Priority</mat-label>
          <mat-select [(ngModel)]="task.priority" required [compareWith]="functions.valueComparisonFunction">
            <mat-option value="High">High</mat-option>
            <mat-option value="Normal">Normal</mat-option>
            <mat-option value="Low">Low</mat-option>
          </mat-select>
        </mat-form-field>

      </div>
    </div>
  </div>
</div>